module.exports = __webpack_public_path__ + "static/media/question_icon-blu.eb3b144b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question_bank/question_icon-blu.svg
// module id = 303
// module chunks = 0